import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import unavailableHeavyProducts from '~/const/patch';
const COLORS = {
  IN_STOCK: 'green',
  UNAVAILABLE: 'red',
  SOON: 'orange',
  MONTH: 'orange',
  WEEK: 'orange',
  LIMITED: 'orange',
  STORE_ONLY: 'black',
  DELETE: 'white',
  default: 'black'
};
export default {
  name: 'ProductStock',
  props: {
    stock: {
      type: Object,

      default() {
        return {};
      }

    },
    showOnlyInStock: {
      type: Boolean,
      default: false
    },
    reference: {
      type: String,
      default: ''
    }
  },
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  }), {
    currentStock() {
      if (this.stock.status === 'STORE_ONLY' && unavailableHeavyProducts(this.reference, this.locale.iso)) {
        return this.$t('unavailable');
      }

      return this.stock.message || this.$t('IN_STOCK');
    },

    color() {
      return COLORS[this.stock.status] || COLORS.default;
    }

  })
};